import { Box, Card, CardContent, Grid, Typography } from '@material-ui/core';
import { Link } from "@material-ui/icons";
import React, { Component } from 'react';

export interface SectionProps {
    title: string;
    description: string;
    linkUrl: string;
}

export class ListItem extends Component<SectionProps> {
    render() {
        const { title, description, linkUrl } = this.props;
        return (
          <Grid item xs={12} sm={12} md={6}>
            <Card
              onClick={() => window.open(linkUrl, '_blank')}
              style={{ boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)' }}
            >
              <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginLeft: 15 }}>
                <Link />
                <CardContent>
                  <Typography variant="h5" component="div">
                    {title}
                  </Typography>
                  <Typography>
                    {description}
                  </Typography>
                </CardContent>
              </Box>
            </Card>
          </Grid>
        );
    }
}

